import { PlantMaterialSchemaZod } from "src/features/create-accession/components/add-plant-material-form/schema";
import { z } from "zod";
import { accessionOptionSchema } from "./accession-option";

export const newMaterialSchema = PlantMaterialSchemaZod.and(
  z.object({ accessionOption: accessionOptionSchema }),
);

export type NewMaterialSchema = z.TypeOf<typeof newMaterialSchema>;
export type NewMaterialSchemaInput = z.input<typeof newMaterialSchema>;
